
import React, { useState, useContext } from "react";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Link } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { useNavigate } from "react-router-dom";
import { OrderContext } from "../contexts/OrderContext";
import { useLocation } from "react-router-dom";


let outletName = "";
let logo = "binix-Logo.png"
let outletAddress = ""
let Login_Name = "";
let Login_Mobile = "";

const getActiveStyle = (path, currentPath = '') => {
  return currentPath === path ? { backgroundColor: "#f0f0f0", fontWeight: "normal", color: 'blue' } : {};
};


const useStyles1 = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: "auto",
  },
});

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: 2,
  },
}));

export const Logininfo = (LoginName, LoginMobile) => {

  Login_Name = LoginName;
  Login_Mobile = LoginMobile;
  //alert(Login_Name);
}

export const changeOutletName = (name, logoPath, coutAddress) => {
  outletName = name;
  logo = logoPath;
  outletAddress = coutAddress;
}

export default function SwipeableTemporaryDrawer() {
  const location = useLocation();
  const { setCartQuantity, encryptedURL } = useContext(OrderContext);
  // const [Logininfo, setlogininfo] = useState(false);
  const [LoginInfo, setLoginInfo] = React.useState(false)
  const [popUp, setPopUpLogin] = useState(false)
  const [OutletpopUp, setPopUpOutlet] = useState(false)

  const [menushow, setmenushow] = useState(false)
  const classes = useStyles();

  let Logout_status = localStorage.getItem("loginstatus");
  let outletstatus = localStorage.getItem("cartId");

  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  let history = useNavigate();
  const clearLocalStoargeofLoginInfo = () => {


    window.localStorage.removeItem("RoomNo");
    window.localStorage.removeItem("GuestName");
    window.localStorage.removeItem("currentUser");
    window.localStorage.removeItem("loginstatus");
    window.localStorage.removeItem("Billtype");
    window.localStorage.removeItem("OutLetName");
    history.push("/")

  }


  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    // alert(popUp),
    <div
      style={{ textAlign: "center" }}
      className={clsx(classes.list, {
        [classes.fullList]: anchor === "top" || anchor === "bottom",
      })}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <div >
        {/* <Link to='/' style={{ textDecoration: 'none' }}><img src={"Logo/" + logo} alt="Menu" /></Link> */}
        <img src={"Logo/" + logo} alt="Menu" />
        <Divider /> </div>
      <span
        className="card-title"
        style={{ width: "15%", fontSize: "14px", fontWeight: "600" }}
      >
        {/* <hr style={{  border:' 1px solid #b7b4b4 !important',padding:'0px',margin:'0px;'}} /> */}
        {/* {localStorage.getItem("OutLetName")} */}
        {outletName}


      </span>
      <br />
      <span
        className="card-title"
        style={{ width: "15%", fontSize: "14px", fontWeight: "600" }}
      >   {outletAddress}</span>
      <br />
      <span>
        {localStorage.getItem("GuestName")}
        {/* {Login_Name} */}
      </span>
      <br />
      <span>
        {localStorage.getItem("RoomNo")}
        {/* {Login_Mobile} */}
      </span>
      <br />
      <span style={{ width: "15%", fontSize: "14px", fontWeight: "600", color: "blue" }}>
        {localStorage.getItem("PropertyName")}
      </span>
      <br />
      {/*   <span style={{ width: "15%", fontSize: "14px", fontWeight: "600", color: "blue" }}>
        {"Online Order Taking"}
      </span> */}


      {localStorage.getItem("OutLetName") !== null ? (
        // <Link to='/store' style={{ textDecoration: 'none' }}>
        <ListItem button key='Menu' onClick={() => setPopUpOutlet(true)}>
          <ListItemIcon> <i class="fa fa-bars"></i> </ListItemIcon>
          Menu
        </ListItem>
        // </Link>
      ) : (null
      )}
      <Divider />
      <List>
        {/* <Link to='/QRscanner' style={{ textDecoration: 'none' }}>
          <ListItem button key='QR Scanner' >
            <ListItemIcon> <i class="fa fa-qrcode"></i> </ListItemIcon>
            QR Scanner
            
          </ListItem>
        </Link> */}
        <Divider />




        {Logout_status !== null ? (
          <Link to='/PastOrders' style={{ textDecoration: 'none' }}>
            <ListItem button key='Past Orders'>
              <ListItemIcon> <i class="fa fa-address-card"></i> </ListItemIcon>
              Past Orders
            </ListItem></Link>
        ) : (null
        )}





        <Divider />

        {/* <Link to="/AdminDashBoard" style={{ textDecoration: 'none' }}>
          <ListItem button key='Admin DashBoard'>
          <ListItemIcon> <i class="fa fa-address-card"></i> </ListItemIcon>
          DashBoard
        </ListItem>
        </Link> */}








        {/* <Link to="/StewardAccept" style={{ textDecoration: 'none' }}>

<ListItem button key='Steward Order Accpet'>
  <ListItemIcon> <i class="fa fa-address-card"></i> </ListItemIcon>
  Steward Order Accept
</ListItem>

</Link> */}



        {/* 
        {Logout_status !== null ? (<Link to="/Location" 
        style={{ textDecoration: 'none' }}> <ListItem button key='Track Delivery' >
          <ListItemIcon> <i class="fa fa-map-marker" aria-hidden="true"></i> </ListItemIcon>
          <ListItemText primary='Track Delivery' />
        </ListItem></Link>
        ) : null} */}





        {/* {outletstatus !== null ? (<ListItem button key='Call Steward' >
          <ListItemIcon> <i class="fa fa-phone" aria-hidden="true"></i> </ListItemIcon>
          <ListItemText primary='Call Steward' />
        </ListItem>) : null} */}


        {Logout_status !== null ? (<ListItem button key='Log Out' onClick={() => clearLocalStoargeofLoginInfo()}>
          <ListItemIcon> <i class="fa fa-sign-out"></i> </ListItemIcon>
          <ListItemText primary='Log Out' />
        </ListItem>
        ) : null}
        {outletstatus !== null && Logout_status === null ? (<ListItem button key='Login' onClick={() => setPopUpLogin(true)} >
          <ListItemIcon> <i class="fa fa-sign-in" aria-hidden="true"></i> </ListItemIcon>
          <ListItemText primary='Login' />
        </ListItem>) : null}
      </List>
      <Link to={`/home?data=${encryptedURL}`} style={{ textDecoration: 'none', marginBottom: '20px' }}>
        <ListItem button key='Dashboard' style={{ color: 'black', ...getActiveStyle('/home', location.pathname) }}>
          <img src="img/dashboard.png" alt="Menu" width={20} height={20} style={{ marginRight: '10px' }} />
          Dashboard
        </ListItem></Link>

      <Link to={`/order?data=${encryptedURL}`} style={{ textDecoration: 'none', marginBottom: '20px' }}>
        <ListItem button key='New Order' style={{ color: 'black', ...getActiveStyle('/order', location.pathname) }}>
          {/* <ListItemIcon> <i class="fa fa-cutlery"></i> </ListItemIcon> */}
          <img src="img/food.png" alt="Menu" width={20} height={20} style={{ marginRight: '10px' }} />
          Menu Order
        </ListItem></Link>
      <Link to={`/orderstatus?data=${encryptedURL}`} style={{ textDecoration: 'none', marginBottom: '20px' }}>
        <ListItem button key='Order Status' style={{ color: 'black', ...getActiveStyle('/orderstatus', location.pathname) }} >
          <img src="img/preparing.png" alt="Menu" width={20} height={20} style={{ marginRight: '10px' }} />
          Current Order Status
        </ListItem></Link>

      <Link to={`/housekeeping?data=${encryptedURL}`} style={{ textDecoration: 'none', marginBottom: '20px' }}>
        <ListItem button key='Housekeeping' style={{ color: 'black', ...getActiveStyle('/housekeeping', location.pathname) }} >
          {/* <ListItemIcon> <i class="fa fa-cutlery"></i> </ListItemIcon> */}
          <img src="img/pickedup.png" alt="Menu" width={20} height={20} style={{ marginRight: '10px' }} />
          Call Steward
        </ListItem></Link>


      <Link to={`/feedback?data=${encryptedURL}`} style={{ textDecoration: 'none' }}>
        <ListItem button key='Feedback' style={{ color: 'black', ...getActiveStyle('/feedback', location.pathname) }}>
          {/* <ListItemIcon> <i class="fa fa-cutlery"></i> </ListItemIcon> */}
          <img src="img/feedback.png" alt="Menu" width={20} height={20} style={{ marginRight: '10px' }} />
          Feedback
        </ListItem></Link>

      <Link to={`/order?data=${encryptedURL}`} onClick={() => {
        localStorage.clear();
        setCartQuantity([]); // Clear the cart state
      }} style={{ textDecoration: 'none' }}>
        <ListItem button key='clear all' style={{ color: 'red' }} >
          <img src="img/trash.png" alt="Menu" width={20} height={20} style={{ marginRight: '10px' }} />
          Clear All
        </ListItem>

      </Link>

      <div >
        {/*  <img src={"img/dining.png"} alt="food" /> */}
        <Divider /> </div>
      {/* <Link to="/paymentpagePaytm" style={{ textDecoration: 'none' }}>
<ListItem button key='paymentpagePaytm'>
  <ListItemIcon> <i class="fa fa-address-card"></i> </ListItemIcon>
  Buy Now 
</ListItem>
</Link> */}
      {/* 
<Link to="/buynow" style={{ textDecoration: 'none' }}>
<ListItem button key='buynow'>
  <ListItemIcon> <i class="fa fa-address-card"></i> </ListItemIcon>
  Buy Now  
</ListItem>
</Link>


      <Link to='/About' style={{ textDecoration: 'none' }}>

  <ListItem button key='About Us'>
  <ListItemIcon> <i class="fa fa-address-card"></i> </ListItemIcon>
  About Us
  </ListItem>

</Link>
<Link to="/contactus" style={{ textDecoration: 'none' }}>
<ListItem button key='contactus'>
  <ListItemIcon> <i class="fa fa-address-card"></i> </ListItemIcon>
  Contact Us
</ListItem>
</Link>

<Link to="/privacypolicy" style={{ textDecoration: 'none' }}>
<ListItem button key='privacypolicy'>
  <ListItemIcon> <i class="fa fa-address-card"></i> </ListItemIcon>
  Privacy Policy
</ListItem>
</Link>

<Link to="/termsconditions" style={{ textDecoration: 'none' }}>
<ListItem button key='termsconditions'>
  <ListItemIcon> <i class="fa fa-address-card"></i> </ListItemIcon>
  Terms & Conditions
</ListItem>
</Link> */}


      <Divider />
    </div>
  );

  return (
    <div>
      {["left"].map((anchor) => (
        <React.Fragment key={anchor}>
          <div className={classes.root}>

            <AppBar position="static" >
              <Toolbar variant="dense">
                <IconButton onClick={toggleDrawer(anchor, true)} edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
                  <MenuIcon />&nbsp;&nbsp;&nbsp;

                </IconButton>
                <span className="outletname" style={{ textAlign: 'left', fontSize: '20px', width: '70%' }} >
                  {localStorage.getItem("GuestName")}
                  &nbsp;&nbsp;

                </span>
                <span style={{ fontSize: '18px', width: '30%', textAlign: 'right' }}>
                  {/* {localStorage.getItem("Name")} */}
                  &nbsp;&nbsp;
                  {localStorage.getItem("RoomNo")}</span>
                <section className={classes.rightToolbar}>
                  {/* <Typography variant="h6" className={classes.title}>
                  BINIX POS
  </Typography> */}
                  {/* <Button color="inherit">QR Scanner</Button> */}
                </section>
              </Toolbar>
            </AppBar>
          </div>









          <SwipeableDrawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
            onOpen={toggleDrawer(anchor, true)}
          >
            {list(anchor)}
          </SwipeableDrawer>
        </React.Fragment>
      ))}
    </div>
  );
}
